module.exports = __webpack_public_path__ + "chat_teal_solid.4777c411eb9575285044.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/chat_teal_solid.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/chat_teal_solid.svg
// module chunks = styles